// extracted by mini-css-extract-plugin
module.exports = {"copyButton":"CopyButton-module--copyButton--2n1d6","buttonCopy":"CopyButton-module--buttonCopy--1nnbw","buttonCopied":"CopyButton-module--buttonCopied--3Z3HX"};